import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { classes } from "./classes";

const style = css`
  transition: opacity 200ms;
  opacity: 0;

  &.visible {
    opacity: 1;
  }
`;

export type LoadingProps = { visible: boolean };

export const Loading = ({ visible }: Properties<LoadingProps>) => (
  <svg
    viewBox="0 0 32 32"
    class={$(() => classes(style, resolve(visible) && "visible"))}
  >
    <path
      fill="currentColor"
      d="M28,16c0-6.6-5.4-12-12-12S4,9.4,4,16 M5.9,16c0-5.6,4.5-10.1,10.1-10.1S26.1,10.4,26.1,16"
    >
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur="1s"
        from="0 16 16"
        to="360 16 16"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);
